import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=112c753a&scoped=true"
import script from "./Home.vue?vue&type=script&setup=true&lang=ts"
export * from "./Home.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Home.vue?vue&type=style&index=0&id=112c753a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112c753a",
  null
  
)

export default component.exports